import { render } from "./MenuActionLink.vue?vue&type=template&id=1f50c96c&ts=true"
import script from "./MenuActionLink.vue?vue&type=script&lang=ts"
export * from "./MenuActionLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__